import { render } from "./MoviesList.vue?vue&type=template&id=2dabd358&scoped=true"
import script from "./MoviesList.vue?vue&type=script&lang=js"
export * from "./MoviesList.vue?vue&type=script&lang=js"

import "./MoviesList.vue?vue&type=style&index=0&id=2dabd358&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dabd358"]])

export default __exports__